export default "__VITE_ASSET__81ddda6f__"